// extracted by mini-css-extract-plugin
module.exports = {"container":"WelcomeMessage_container__34l_N","epsa_logo":"WelcomeMessage_epsa_logo__EKVYN"};